<template>
  <div class="ccui-app-container">
    <div class="top">
      <div class="ccui-advanced-search-wrapper ccui-clearfix my-tab">
        <el-button
          class="tab"
          @click="tabChange(item)"
          v-for="item in tabButton"
          :key="item.focus"
          :type="tabShow === item.focus ? 'table-top-active' : 'table-top'"
          size="mini"
          >{{ item.label }}{{ tabShow === item.focus ? `(${totalNum})` : "" }}
        </el-button>
      </div>
    </div>
    <div class="ccui-multifunctional-table-wrapper">
      <!--      tableData-->
      <div class="tableOnly" v-if="tableData.length > 0">
        <div
          class="tableOnlyItem"
          v-for="item in tableData"
          :key="item.messageId"
        >
          <div :class="item.isRead ? 'white' : 'red'"></div>
          <div class="tableOnlyItemLeft">
            <div class="left">
              <img class="img" src="../img/supplier.png" alt="" />
              <div class="titleBox">
                <span class="title">待报价询价单提醒</span>
                <div class="titleBodyWrapper">
                  <span class="titleBody"> 询价单号：{{ item.seekCode }} </span>
                  <span class="blue" @click="handleDetail(item)">详情</span>
                </div>
              </div>
            </div>
            <div class="right">
              {{ item.createTime ? item.createTime.substring(0, 10) : "" }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        style="font-size: 14px;color: #999;text-align: center;
    margin-top: 20%;"
      >
        暂无数据
      </div>

      <div class="ccui-table-footer" v-if="totalNum > 0">
        <div id="ccui-paging">
          <el-pagination
            :total="totalNum"
            :page-size="getLocalPageSize()"
            :current-page="formDataSearch.pageNo"
            :page-sizes="[10, 20, 50, 100, 200, 500]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSessionItem } from "@/basa/utils";
import { readMessage } from "../api/all";

export default {
  name: "issueTable",
  props: {
    tabShow: String,
    totalNum: Number,
    // 表格数据
    tableData: Array,
    loading: Boolean,
    dialogVisible: Boolean
  },
  data() {
    return {
      tabButton: [{ focus: "all", label: "全部" }],
      optionsLists: {
        tongzhileixing: [
          {
            value: 1,
            label: "发送通知"
          },
          {
            value: 2,
            label: "政策公告"
          },
          {
            value: 3,
            label: "文件文档"
          }
        ]
      },
      tableHack: true,
      tableTheadOptions: [],
      tableSelectLists: [],
      formData: {
        pageNo: 1,
        pageSize: this.getLocalPageSize(),
        isShowPageLoading: false
      },
      formDataSearch: {
        pageNo: 1,
        pageSize: this.getLocalPageSize(),
        isShowPageLoading: true
      },
      // 表格数据
      tableThead: [],
      tableName: "inquiryForm",
      fixedTableThead: [],
      options: [
        {
          value: 1,
          label: "详情"
        }
      ],
      dialogTitle: "",
      dialogForm: {
        cancelReason: "",
        seekOffTime: null
      },
      dialogFormRules: {
        seekOffTime: [{ required: true, message: "请输入", trigger: "blur" }],
        cancelReason: [{ required: true, message: "请输入", trigger: "blur" }]
      },
      handleClickRow: {}
    };
  },
  activated() {
    // this.getList(this.formDataSearch);
  },
  mounted() {},
  methods: {
    tabChange(item) {
      this.$router.push(`/instationMessage/issue/${item.focus}`);
    },
    handleDetail({ seekMessageId }) {
      readMessage({ seekMessageId }).then(res => {
        this.$router.push({
          path: `/inquiry/inquiryLists/pending`
          // query: {
          //   type: "detail",
          //   messageId: item.messageId
          // }
        });
      });
    },
    search(searchData) {
      this.formDataSearch.pageNo = 1;
      this.formDataSearch.pageSize = 10;
      this.formDataSearch = searchData;
      this.getList(this.formDataSearch);
    },
    resetForm() {
      this.formData = {};
      this.formData.pageNo = 1;
    },
    // 查看
    cellClick(row, column, columnIndex) {
      if (["skuId"].includes(column.property)) {
        // this.goDetail(row)
      }
    },
    // 根据返回状态显示不同的文字颜色
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (["skuId"].includes(column.property)) {
        // return { color: '#0089EF', cursor: 'pointer' }
      }
    },
    // 表格宽度更改存入
    handleSelectionChange(rows) {
      this.tableSelectLists = rows;
    },
    getLocalPageSize() {
      return getSessionItem("pageSize", this.tableList.inventoryInbound) || 10;
    },
    // 当前页码更改
    handleCurrentChange(val) {
      // 跳转翻页都会调这个方法
      this.formDataSearch.pageNo = val;
      this.getList(this.formDataSearch);
    },
    handlePrev() {},
    // 下一页
    handleNext() {},
    handleSizeChange(val) {
      this.formDataSearch.pageNo = 1;
      this.formDataSearch.pageSize = val;
      // setSessionItem("pageSize", this.tableName, val);
      this.getList(this.formDataSearch);
    },
    filteredOptions(row) {
      const optionsMap = {
        1: [this.options[0], this.options[1], this.options[2]],
        2: [this.options[0], this.options[2]],
        3: [this.options[0], this.options[2]]
      };

      return optionsMap[1] || [];
    },
    handleClick(row, value) {
      this.dialogTitle = value.label;
      this.handleClickRow = row;
      if (
        this.dialogTitle === "取消" &&
        this.handleClickRow.seekType === 2 &&
        this.handleClickRow.quoteSuppliersCount < 3
      ) {
        this.dialogForm.cancelReason = "响应报价供应商数量小于 3";
      }
      this.$emit("handleClick", row, value, this.dialogForm);
    },
    getList(data) {
      this.$emit("child-event", data);
    },

    dialogFormCancel() {
      this.$emit("dialogFormCancel", false);
      // this.dialogForm = {}
      // this.$refs["dialogFormRef"].resetFields();
    },
    dialogVisibleHid() {
      this.$emit("dialogVisibleHid", false);
    },
    validateForm(callback) {
      this.$refs.dialogFormRef.validate(valid => {
        callback(valid);
      });
    },
    resetFields() {
      this.dialogForm = {
        seekOffTime: null,
        cancelReason: ""
      };
      this.$refs["dialogFormRef"].resetFields();
    },
    cancelReasonInput(val) {
      this.dialogForm.cancelReason = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.tab {
  margin-right: 15px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
}
/deep/.el-button + .el-button,
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 15px;
}
/deep/.el-searchs-box {
  margin-right: 75px;
}
/deep/.el-button.el-button--table-top-active {
  padding: 4px 0;
}

.top {
  margin-bottom: 20px;
}

/deep/ .el-search .el-searchs {
  margin-top: -30px;
}
/deep/.el-search {
  overflow: inherit !important;
}
/deep/.optionHeight {
  height: 100%;
}
/deep/.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #ff142f !important;
}
/deep/.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  color: #ff142f !important;
}
</style>
<style lang="scss" scoped>
.tableOnly {
  .tableOnlyItem {
    display: flex;
    margin-left: 20px;
    padding-right: 10px;
    //width: 95%;

    .red {
      width: 10px;
      height: 10px;
      background: #ff142f;
      border-radius: 5px;
      margin: 35px 10px 21px 0;
    }
    .white {
      width: 10px;
      height: 10px;
      background: transparent;
      border-radius: 5px;
      margin: 35px 10px 21px 0;
    }

    .tableOnlyItemLeft {
      width: 97%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f1f1f1;

      .left {
        display: flex;
        align-items: center;
        padding: 21px 0;
        width: 87%;

        .img {
          width: 30px;
          height: 30px;
          margin-right: 20px;
        }

        .titleBox {
          display: flex;
          flex-direction: column;
          overflow: hidden;

          .title {
            font-size: 13px;
            color: #4a4a4a;
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .titleBodyWrapper {
            display: flex;
            align-items: center;

            .titleBody {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #999;
              font-size: 13px;
            }

            .blue {
              flex-shrink: 0;
              font-size: 13px;
              display: inline-block;
              color: #409eff;
              cursor: pointer;
              margin-left: 8px;
            }
          }
        }
      }
      .right {
        font-size: 12px;
        color: #999;
        width: 100px;
        text-align: right;
      }
    }

    .tableOnlyItemLeft:first-child .left {
      padding-top: 0;
    }
  }
}
</style>
<style>
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #ff142f !important;
}
.el-search .duidui {
  font-size: 13px !important;
  color: #999;
}
</style>
